<template>
  <div class="w-180px">
    <a
      href="https://app.zeplin.io/project/5f092773fa16ac9ddd3d2a2f/screen/5f0e7b0ca142158f14f60a55"
      >Colr & Typography</a
    >

    <h3>Text Color</h3>
    <div class="brand-01-emphasis--text" color="">
      brand-01-emphasis text
    </div>
    <div class="danger-01-emphasis--text">success-500 background</div>
    <div class="text-color-ink">text-color-ink text</div>

    <h3>Fill</h3>
    <div class="warning-500">warning-500 background</div>
    <div class="success-500--text" color="">success-500 text</div>
    <div class="fill-gray">fill-gray background</div>

    <h3>Font Family</h3>
    <div>測試測試 this is a test</div>

    <h3>Icon Font</h3>
    <v-form>
      <v-text-field label="Username" prepend-icon="account_circle">
      </v-text-field>

      <v-text-field
        :type="showPassword ? 'text' : 'password'"
        label="Password"
        prepend-icon="lock"
        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
        @click:append="showPassword = !showPassword"
      ></v-text-field>
    </v-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    showPassword: false,
  }),
};
</script>

<style lang="scss">
.text-color-ink {
  // color: var(--v-danger-01-emphasis-base); // not work perfect in IE11
  color: $danger-01-emphasis; // work in IE11
}
.fill-gray {
  background-color: $gray-100;
}
</style>
